import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { routesMap } from './routes';

export const routes: Routes = [
  {
    path: routesMap.dashboard.getOwnName,
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: routesMap.auth.getOwnName,
    loadChildren: () => import('./auth-ion-components/auth-components.module').then(m => m.AuthComponentsModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor() {
  }
}
